import { Box, CircularProgress, Dialog, Divider, IconButton, Typography } from "@mui/material"
import { CloseOutlined } from "@mui/icons-material"
import { FC, useEffect, useState } from "react"
import { Apis } from "../../helpers"

interface Props {
    close: () => void
}
interface StateProps {
    loading: boolean
    roles: Record<string, string[]>
}

const RolesInfoModal: FC<Props> = ({ close }) => {
    const [state, setState] = useState<StateProps>({ loading: true, roles: {} })
    const { loading, roles } = state

    useEffect(() => {
        Apis({ module: 'General', action: 'getRoles' })
            .then((resp: any) => {
                const { fetched, ...rest } = resp || {}
                setState({ loading: false, roles: rest })
            })
            .catch(() => setState(s => ({ ...s, loading: false })))
    }, [])

    const roleNames = Object.keys(roles)

    return (
        <Dialog open onClose={close} maxWidth="xs" fullWidth PaperProps={{ sx: { borderRadius: 3 } }}>
            <Box sx={{ p: 3 }}>
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 2 }}>
                    <Typography sx={{ fontSize: 16, fontWeight: 800 }}>Collaborator Roles</Typography>
                    <IconButton size="small" onClick={close}>
                        <CloseOutlined sx={{ fontSize: 18 }} />
                    </IconButton>
                </Box>

                {loading ? (
                    <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}><CircularProgress size={24} /></Box>
                ) : (
                    roleNames.map((role, i) => (
                        <Box key={role}>
                            {i > 0 && <Divider sx={{ my: 1.5 }} />}
                            <Typography sx={{ fontSize: 13, fontWeight: 800, mb: 0.5 }}>{role}</Typography>
                            <Box component="ul" sx={{ m: 0, pl: 2.5 }}>
                                {roles[role].map((line, j) => (
                                    <Typography key={j} component="li" sx={{ fontSize: 12.5, color: 'text.secondary', mb: 0.3 }}>
                                        {line}
                                    </Typography>
                                ))}
                            </Box>
                        </Box>
                    ))
                )}
            </Box>
        </Dialog>
    )
}

export default RolesInfoModal
